import Vue from 'vue';
import store from '@/core/store';

class GTM {
  static trackEvent (payload) {
    if (window.sbvrenv.NODE_ENV === 'development') {
      console.log('GTM', payload);
    }
    const dataLayer = window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'interaction',
      ...payload,
    });
  }
}
// GTM
Vue.use({
  install (vue) {
    // Add to vue prototype and also from globals
    Vue.prototype.$gtm = Vue.gtm = GTM;
  },
});

store.subscribe(({ type, payload }) => {
  const namesMap = {
    setFilters: {
      category: 'Filters',
      action: 'change',
    },
    setSearch: {
      category: 'Search',
      action: 'change',
      label: ({ payload }) => payload,
      payloadName: 'searchQuery',
    },
    setSearchedGames: {
      category: 'Search',
      action: 'results',
      value: ({ payload }) => payload.length,
      payloadName: 'gameIds',
    },
  };
  const mutationsToTrack = Object.keys(namesMap);
  if (mutationsToTrack.includes(type)) {
    const formattedPayload = typeof payload === 'object' && !Array.isArray(payload)
      ? JSON.parse(JSON.stringify(payload))
      : { [namesMap[type].payloadName || 'payload']: payload };
    const getTrackingInfo = (name) => {
      const value = namesMap[type][name];
      if (!value) return '';
      else if (typeof value === 'function') return value({ store, payload });
      else return namesMap[type][name];
    };
    const data = {
      ...formattedPayload,
      category: getTrackingInfo('category'),
      action: getTrackingInfo('action'),
      value: getTrackingInfo('value'),
      label: getTrackingInfo('label'),
      event: 'mutation',
      stationId: store.getters.stationId,
    };
    GTM.trackEvent(data);
  }
  if (type === 'route/ROUTE_CHANGED') {
    GTM.trackEvent({
      ...payload.to.meta,
      event: 'navigation',
      stationId: store.getters.stationId,
    });
  }
});
